import { useQuery } from "@tanstack/react-query";
import { api as badgeCenterApi } from "../../../services/apis/badge-center";

export type XPLimits = {
  user_id: string;
  daily_xp_today: number;
  daily_xp_cap: number;
  daily_xp_limit_reached: boolean;
  xp_resets_at: string;
};

export function useXPLimit(userId: string | undefined) {
  return useQuery({
    queryKey: ["xp-limits", userId],
    queryFn: () => badgeCenterApi.getLimits(),
    enabled: !!userId,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
